import { fetchTeachers } from "./asyncThunks";

export const fetchTeachersBuilder = (builder) => {
  builder.addCase(fetchTeachers.pending, (state) => {
    state.fetchTeachersPending = true;
  });
  builder.addCase(fetchTeachers.fulfilled, (state, action) => {
    state.fetchTeachersPending = false;
    state.teachers.data = action.payload.data.map((te) => {
      te.name = te.firstName + " " + te.lastName;
      return te;
    });
    state.teachers.total = action.payload.total;
  });
  builder.addCase(fetchTeachers.rejected, (state) => {
    state.fetchTeachersPending = false;
  });
};
